export default __webpack_public_path__ + "images/travel.c818bf3.jpg";